<empty-layout *ngIf="layout === 'empty'"></empty-layout>
<main-layout *ngIf="layout === 'main'"></main-layout>
